var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"title":"Suarchyvuotos finansavimo užklausos","subtitle":"Čia galite peržiūrėti suarchyvuotas finansavimo užklausas"}}),_c('DataTable',{ref:"archivedFundingRequestsTable",attrs:{"table":_vm.table}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }